/**
 * Labels para subrutas profundas que NO existen en el menú del backend.
 *
 * El trail de breadcrumbs se construye primero desde la jerarquía del menú
 * (refleja permisos y nombres por tenant); este mapa solo cubre el último
 * tramo de rutas con parámetros (`/empresas/:id`, etc.) que el menú no conoce.
 *
 * Los patrones se anclan al FINAL del pathname (no al inicio) para tolerar
 * el prefijo de tenant (`/claricel/empresas/12`).
 */
export const ROUTE_LABELS: Array<{ pattern: RegExp; label: string }> = [
  { pattern: /\/empresas\/[^/]+$/, label: "Detalle de Empresa" },
]

/** Label de subruta profunda para un pathname, o null si no aplica. */
export function deepRouteLabel(pathname: string): string | null {
  const match = ROUTE_LABELS.find(({ pattern }) => pattern.test(pathname))
  return match ? match.label : null
}
